var _path, _rect, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83271 10.9654C2.60171 12.6151 1.28617 14.8425 1.28617 17.245C1.28617 19.6475 2.60171 21.8749 4.83271 23.5246C7.06356 25.1742 10.176 26.2139 13.6419 26.2139C17.1079 26.2139 20.2203 25.1742 22.4512 23.5246C24.6822 21.8749 25.9977 19.6475 25.9977 17.245C25.9977 14.8425 24.6822 12.6151 22.4512 10.9654C20.2203 9.31583 17.1079 8.27616 13.6419 8.27616C10.176 8.27616 7.06356 9.31583 4.83271 10.9654ZM4.06801 9.93128C6.54183 8.10203 9.92883 6.98999 13.6419 6.98999C17.3551 6.98999 20.7421 8.10203 23.2159 9.93128C25.6895 11.7604 27.2839 14.339 27.2839 17.245C27.2839 20.1511 25.6895 22.7296 23.2159 24.5588C20.7421 26.388 17.3551 27.5001 13.6419 27.5001C9.92883 27.5001 6.54183 26.388 4.06801 24.5588C1.59435 22.7296 0 20.1511 0 17.245C0 14.339 1.59435 11.7604 4.06801 9.93128Z",
    fill: "url(#paint0_linear_5580_23079)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.20898,
    y: 14.9355,
    width: 21.122,
    height: 13.9851,
    rx: 2,
    transform: "rotate(-45 4.20898 14.9355)",
    fill: "url(#paint1_linear_5580_23079)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4448,
    y: 7.89563,
    width: 6.27196,
    height: 9.42058,
    rx: 2,
    transform: "rotate(-45 14.4448 7.89563)",
    fill: "#1A2037"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5580_23079",
    x1: 22.1826,
    y1: 8.70535,
    x2: 5.10227,
    y2: 25.7857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5580_23079",
    x1: 4.20898,
    y1: 16.0969,
    x2: 51.525,
    y2: 47.3385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386317,
    stopColor: "#00BFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2037"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5cb26966fca0e9444b5def813b031823.svg";
export { ForwardRef as ReactComponent };